/** App-wide toast helpers (sonner). Duration defaults to 3s. */
import { toast } from 'sonner';

const DURATION = 3000;

export function notifySuccess(message) {
  if (!message) return;
  toast.success(String(message), { duration: DURATION });
}

export function notifyError(message) {
  if (!message) return;
  toast.error(String(message), { duration: DURATION });
}

export function notifyInfo(message) {
  if (!message) return;
  toast.message(String(message), { duration: DURATION });
}
